import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { getDefault } from '../data/contentSchema';

export const useContent = (page) => {
  const [overrides, setOverrides] = useState({});
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    let alive = true;
    api.get(`/content/${page}`)
      .then((r) => { if (alive) setOverrides(r.data.overrides || {}); })
      .catch(() => { if (alive) setOverrides({}); })
      .finally(() => { if (alive) setLoaded(true); });
    return () => { alive = false; };
  }, [page]);
  // Saved value wins (even empty, so text can be removed); otherwise the schema default.
  const t = (key, fallback) => {
    if (overrides[key] != null) return overrides[key];
    const d = getDefault(page, key);
    return d !== undefined ? d : fallback;
  };
  return { overrides, t, loaded };
};

// Renders *word* as italic.
export const rich = (text) => String(text || '').split(/\*(.+?)\*/g).map((part, i) =>
  i % 2 ? React.createElement('span', { key: i, className: 'italic' }, part) : part
);

export const useTeam = () => {
  const [members, setMembers] = useState(null);
  useEffect(() => {
    let alive = true;
    api.get('/team')
      .then((r) => { if (alive) setMembers(r.data || []); })
      .catch(() => { if (alive) setMembers([]); });
    return () => { alive = false; };
  }, []);
  return members;
};
